<bdo-text-box-page
  [boxTitle]="'noService.vebOutExisting.title' | translate"
  [infoText]="'noService.vebOutExisting.description' | translate"
  [linkData]="linkData"
></bdo-text-box-page>
